__turbopack_context__.v({
  "cardSelected": "QniHOG_cardSelected",
  "contentContainer": "QniHOG_contentContainer",
});
